/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './UserDetailsSection.style';

type Props = {
  label?: string,
  children?: any,
};

const useStyles = createUseStyles(styles);

const UserDetailsSection = ({ label, children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const labelElt = label && <p className={classes.label}>{label}</p>;

  return (
    <section className={classes.root}>
      {labelElt}
      {children}
    </section>
  );
};

export default compose(React.memo)(UserDetailsSection);
